import apiClient from '@/api/client'
import { getApiBaseUrl } from '@/api/base-url'

/**
 * Mercure hub token/status transport. Owned by the platform (common) module:
 * every feature that needs realtime updates authenticates against the same
 * hub connection, so the endpoint must not live inside a single feature
 * module (see task 11 - notifications/Mercure platform boundary).
 */
export interface MercureTokenResponse {
  success: boolean
  data?: {
    token: string
    mercure_url: string
    user_id: number
    topics: string[]
  }
  error?: string
}

const apiUrl = getApiBaseUrl()

export const realtimeApi = {
  async getMercureToken(): Promise<MercureTokenResponse> {
    const response = await apiClient.get(`${apiUrl}/api/mercure/token`)
    return response.data
  },

  async getStatus(): Promise<{
    success: boolean
    mercure_url?: string
    mercure_public_url?: string
    timestamp?: number
  }> {
    const response = await apiClient.get(`${apiUrl}/api/mercure/status`)
    return response.data
  },
}
